import gql from 'graphql-tag'
import client from '@stores/apollo'

const updateUsageTypeQuery = gql`
  mutation UpdateSpacesUsageTypes($input: UpdateUsageTypesMutationInput!) {
    updateUsageTypes(input: $input) {
      spaces {
        id
        code
      }
    }
  }
`

export function batchUpdateUsageTypes(ids: string[], usageType: string) {
  return client.gql
    .mutate({
      mutation: updateUsageTypeQuery,
      variables: { input: { ids, usageType } },
    })
    .then((data: any) => data)
}

const updateSpaceTypesQuery = gql`
  mutation UpdateSpacesSpaceTypes($input: UpdateSpacesTypeMutationInput!) {
    updateSpacesType(input: $input) {
      spaces {
        id
        code
      }
    }
  }
`

export function batchUpdateSpaceTypes(ids: string[], spaceType: string) {
  return client.gql
    .mutate({
      mutation: updateSpaceTypesQuery,
      variables: { input: { ids, spaceType } },
    })
    .then((data: any) => data)
}
